import { useQuery } from '@tanstack/react-query';
import { CustomerApi } from '../api';
import { authKeys } from '../queryKeys';
import type { CustomerInfoData } from '@/lib/types/Customer';

interface UseCustomerInfoOptions {
  enabled?: boolean;
}

export function useCustomerInfo(
  cId: number | null,
  options: UseCustomerInfoOptions = {}
) {
  return useQuery<CustomerInfoData>({
    queryKey: authKeys.customerInfo(cId!),
    queryFn: () => CustomerApi.getCustomerInfo(cId!),
    enabled: cId !== null && options.enabled !== false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
